import { render, staticRenderFns } from "./SkuTitulo.vue?vue&type=template&id=5bf23330&scoped=true&"
import script from "./SkuTitulo.vue?vue&type=script&lang=js&"
export * from "./SkuTitulo.vue?vue&type=script&lang=js&"
import style0 from "./SkuTitulo.vue?vue&type=style&index=0&id=5bf23330&prod&lang=scss&scoped=true&"
import style1 from "./SkuTitulo.vue?vue&type=style&index=1&id=5bf23330&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf23330",
  null
  
)

export default component.exports